let originalHref: string | null = null;

export function formatBadgeCount(count: number): string {
  return count > 9 ? '9+' : String(count);
}

function getFaviconLink(): HTMLLinkElement | null {
  return document.querySelector<HTMLLinkElement>("link[rel*='icon']");
}

export function setFaviconBadge(count: number): void {
  if (count <= 0) {
    resetFavicon();
    return;
  }

  try {
    const link = getFaviconLink();
    if (!link) return;
    if (originalHref === null) originalHref = link.href;

    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      try {
        const size = 32;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const context = canvas.getContext('2d');
        if (!context) return;

        context.drawImage(image, 0, 0, size, size);

        const radius = 10;
        const centerX = size - radius;
        const centerY = radius;
        context.beginPath();
        context.arc(centerX, centerY, radius, 0, 2 * Math.PI);
        context.fillStyle = '#d32f2f';
        context.fill();

        context.fillStyle = '#ffffff';
        context.font = 'bold 13px Arial, sans-serif';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(formatBadgeCount(count), centerX, centerY + 1);

        link.href = canvas.toDataURL('image/png');
      } catch {
        // Favicon badge is non-critical — the tab title counter still shows the count.
      }
    };
    image.src = originalHref;
  } catch {
    // Favicon badge is non-critical — the tab title counter still shows the count.
  }
}

export function resetFavicon(): void {
  try {
    if (originalHref === null) return;
    const link = getFaviconLink();
    if (link) link.href = originalHref;
  } catch {
    // Favicon badge is non-critical.
  }
}
